import { render, staticRenderFns } from "./SalaryEditDialog.vue?vue&type=template&id=3137188c"
import script from "./SalaryEditDialog.vue?vue&type=script&lang=js"
export * from "./SalaryEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports